<button mat-icon-button class="labeled-actions-buttons" *ngIf="process && process.isRestartSupported"
    (click)="restartProcess($event)" [disabled]="!process.canRestart">
    <mat-icon matTooltip="Restart">
        replay
    </mat-icon>
    <span>{{label}}</span>
</button>
